import Page from 'modules/BiomeAbout'

export default Page

